import { inject, Injectable } from '@angular/core';
import { OrganizationClient } from '../client/organization-client.service';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrganizationStore {
    private readonly _client = inject(OrganizationClient);

    readonly organizations$ = this._client.list().pipe(shareReplay(1));
}
